import { CommonModule } from '@angular/common';
import { Component, Input, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CdwOverlayComponent } from '@cdw-ae/common-ui-components-overlay';

export type IllustrationType = 'illustration-1' | 'illustration-2';

@Component({
  selector: 'lib-cdw-empty-state-overlay',
  imports: [CommonModule, RouterModule, CdwOverlayComponent],
  templateUrl: './empty-state-overlay.component.html',
  styleUrl: './empty-state-overlay.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class EmptyStateOverlayComponent implements AfterViewInit {
  @Input() illustrationType: IllustrationType = 'illustration-1'; // Type of illustration to use
  @Input({ required: true }) htmlContent!: string; // Raw HTML content with links

  constructor(
    private elementRef: ElementRef,
    private router: Router
  ) {}

  ngAfterViewInit(): void {
    // Intercept clicks on links to use Angular router instead of full page refresh
    const links = this.elementRef.nativeElement.querySelectorAll('a[href]');
    links.forEach((link: HTMLAnchorElement) => {
      link.addEventListener('click', (event: Event) => {
        event.preventDefault();
        const href = link.getAttribute('href');
        if (href?.startsWith('/')) {
          this.router.navigate([href]);
        }
      });
    });
  }

  get imageSource(): string {
    const illustrationMap: Record<IllustrationType, string> = {
      'illustration-1': '/images/empty-state/illustration-1.svg',
      'illustration-2': '/images/empty-state/illustration-2.svg',
    };
    return illustrationMap[this.illustrationType];
  }
}
